export enum AnimationDirection {
  Forward = 'animate-forward',
  Backward = 'animate-backward',
  None = 'animate-none',
}
